import { render, staticRenderFns } from "./iconTwitter.vue?vue&type=template&id=308bdb82"
import script from "./iconTwitter.vue?vue&type=script&lang=js"
export * from "./iconTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports